module.exports = __webpack_public_path__ + "img/Flag_of_South_Africa.f8601895.svg";